import { ISorter } from "@/models/tables";
import { FirstNameSorter, LastNameSorter } from "@/data/sorters/client";
import { CreatedAtSorter } from "@/data/sorters/object";

export const DefaultSorters: () => ISorter[] = () => [
  FirstNameSorter({ field: "child_client.firstname" }),
  LastNameSorter({ field: "child_client.lastname" }),
  CreatedAtSorter()
];
